export const disableBackdropClick = false;
export const disableEscapeKeyDown = false;
export const disablePhysicalBackAndroid = false;
export const chooseLangByLabel = true;